import { requestBuilder } from '../../../http/RequestBuilder';

export const useRemoveBeneficiary = requestBuilder.mutation<
    {
        success: boolean;
    },
    {
        id: string;
        bankAccountIds: string[];
    }
>({
    endpoint: '/api/beneficiary/remove-from-accounts',
    method: 'POST',
});
